// extracted by mini-css-extract-plugin
export var blue = "Picto-module--blue--BN1eZ";
export var dash = "Picto-module--dash--xLG3D";
export var inView = "Picto-module--inView--CMLPW";
export var orange = "Picto-module--orange--GVfOZ";
export var picto = "Picto-module--picto--bqCEI";
export var wrapper = "Picto-module--wrapper--nJWLA";